import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectTemplateName = createSelector(
  [(store: RootState) => store.userTemplate.templateName],
  (data) => data
);
